<div class="diferencias-container black-panel" id="diferencias-paciente" #rootElement>
    <div class="container">
        <div>
            <img src="assets/img/logo.png" style="height: 100px" class="m-auto d-block" />
        </div>
        <div class="row">
            <div class="col-10 offset-1">
                <img src="https://api.bealign.com/img/contenidos/17.jpg" class="img-fluid" />
            </div>
        </div>
    </div>
</div>